// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/* eslint-disable
    react/jsx-no-target-blank
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import _ from 'underscore';

import * as analytics from 'analytics/Analytics';
import {StandardDNACodon} from 'biojs/Codons';
import {Sequence} from 'components/Sequence';
import {DESIRED_HR_MISMATCHES, HR_TEMPLATE_STEP, HR_TEMPLATE_TAB_ID} from 'constants/CRISPRConstants';
import {HRTemplateColumn, TargetSite} from 'molbio/crispr/hr-template/HRTemplateStore';
import notifications from 'notifications';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Row from 'ui-library/bs/Row';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {listToReadable} from 'util/NameUtil';

import HRTemplateActions from './HRTemplateActions';
import MutantTable from './MutantTable';

interface Props {
  sequence: Sequence;
  pam: string;
  guide: string;
  warningMessage?: string;
  errorMessage?: string;
  targetSite?: TargetSite;
  columns?: Array<HRTemplateColumn>;
  codonUsage?: Record<StandardDNACodon, number>;
  modifyingSequence: boolean;
  isHRTemplateLoading: boolean;
  resettingToVersion: boolean;
}

class RemoveTargetSiteStep extends React.Component<Props> {
  override componentDidMount(): void {
    HRTemplateActions.setGuide(this.props.sequence.id);
    this.props.sequence.addLockingTab({tabId: HR_TEMPLATE_TAB_ID, tabName: 'HR template design'});
  }

  override componentDidUpdate(prevProps: Props): void {
    // Guide setting triggers mutation suggestion, which should change based on PAM or codon usage loading
    if (prevProps.pam !== this.props.pam || prevProps.codonUsage !== this.props.codonUsage) {
      HRTemplateActions.setGuide(this.props.sequence.id);
    }
  }

  setSelectionEndpoints = (start: number, end: number): void => {
    this.props.sequence.selection().setEndpoints(start, end);
    this.props.sequence.trigger('jump', start);
  };

  override render(): JSX.Element {
    return (
      <form
        onSubmit={function (e: React.FormEvent<HTMLFormElement>): void {
          e.preventDefault();
        }}
      >
        <fieldset>
          <legend>Step 3: Remove target site</legend>
          {(() => {
            if (!this.props.guide) {
              return (
                <div className="alert alert-info">
                  <div className="u-small-spacing-bottom">
                    <strong>Input your guide sequence</strong>
                    {
                      ' (without the PAM) to begin making mutations that remove the target site from your template.'
                    }
                  </div>
                  <div>
                    <em>
                      This step is usually required to prevent re-cutting of the repaired genomic DNA. Click
                      Next to skip it in certain cases (e.g. single nickase with a guide that is sense to the
                      template).
                    </em>
                  </div>
                </div>
              );
            } else if (this.props.columns != null) {
              const modifyHelp = [];
              if (_.any(this.props.columns, (column) => column.isCoding)) {
                modifyHelp.push('clicking on the synonymous codons');
              }
              if (_.any(this.props.columns, (column) => !column.isCoding)) {
                modifyHelp.push('editing the input');
              }

              return (
                <div className="alert alert-info">
                  <div className="u-small-spacing-bottom">
                    <strong>Confirm the mutated bases</strong>
                    {' and click '}
                    <em>Next</em>
                    {' to continue. '}
                    {'Modify the mutations by '}
                    {listToReadable(modifyHelp)}
                    {' below.'}
                  </div>
                  <div>
                    <em>
                      {`Our default suggestion is to mutate the PAM, unless it occurs in a translation with no \
          possible silent mutations. In that case, we try to introduce ${DESIRED_HR_MISMATCHES} \
          mutations in the guide sequence, selecting codons to keep the `}
                      <a
                        // Link is hard to see without underline in alert-info box
                        className="u-text-decoration-underline"
                        href="https://en.wikipedia.org/wiki/Codon_Adaptation_Index"
                        target="_blank"
                      >
                        CAI
                      </a>
                      {' close to the original value.'}
                    </em>
                  </div>
                </div>
              );
            }
            return null;
          })()}
          <FormGroup>
            <Row>
              <Col sm={6}>
                <input
                  type="text"
                  placeholder="Guide"
                  value={this.props.guide}
                  // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
                  onChange={(e) => HRTemplateActions.setGuide(this.props.sequence.id, e.target.value)}
                />
              </Col>
            </Row>
          </FormGroup>
          {this.props.errorMessage ? (
            <FormGroup>
              <Row>
                <Col sm={12}>
                  <div className="alert alert-danger">{this.props.errorMessage}</div>
                </Col>
              </Row>
            </FormGroup>
          ) : (
            <FormGroup>
              {(() => {
                if (this.props.columns != null) {
                  return (
                    <div>
                      <MutantTable
                        sequence={this.props.sequence}
                        pam={this.props.pam}
                        guide={this.props.guide}
                        targetSite={this.props.targetSite}
                        codonUsage={this.props.codonUsage}
                        columns={this.props.columns}
                      />
                      <div>
                        <p className="help-block">
                          {'Bases included to complete triplets are colored '}
                          <span className="text-muted">grey</span>
                          {' and the PAM site is colored '}
                          <span className="text-primary">blue</span>.
                        </p>
                        {this.props.warningMessage ? (
                          <div className="alert alert-warning">{this.props.warningMessage}</div>
                        ) : undefined}
                      </div>
                    </div>
                  );
                } else if (this.props.guide) {
                  return 'Loading...';
                }
                return null;
              })()}
            </FormGroup>
          )}
          <Button
            buttonStyle={ButtonStyle.PRIMARY}
            size={ButtonSize.SMALL}
            className="pull-right"
            disabled={Boolean(
              this.props.errorMessage ||
              this.props.modifyingSequence ||
              this.props.isHRTemplateLoading ||
              this.props.resettingToVersion
            )}
            onClick={() => {
              if (this.props.warningMessage) {
                notifications.error(this.props.warningMessage);
                return;
              }

              // Redundant bases replace to save the version.
              HRTemplateActions.saveMutations(this.props.sequence.id);
              const savedVersions = _.object([
                [HR_TEMPLATE_STEP.SUMMARY, this.props.sequence.getActiveVersionId()],
              ]);
              HRTemplateActions.serverUpdate(this.props.sequence.id, {
                step: HR_TEMPLATE_STEP.SUMMARY,
                savedVersions,
                guide: this.props.guide,
              });
              analytics.track('hr_template', 'completed_step_remove_target_site');
            }}
            text={this.props.modifyingSequence || this.props.isHRTemplateLoading ? 'Loading...' : 'Next'}
          />
          <Button
            buttonStyle={ButtonStyle.TERTIARY_GRAY}
            size={ButtonSize.SMALL}
            disabled={this.props.resettingToVersion || this.props.isHRTemplateLoading}
            onClick={HRTemplateActions.backToStep.bind(
              null,
              this.props.sequence.id,
              HR_TEMPLATE_STEP.SELECT_ARMS
            )}
            text={
              this.props.isHRTemplateLoading
                ? 'Loading...'
                : this.props.resettingToVersion
                  ? 'Resetting...'
                  : 'Back'
            }
          />
        </fieldset>
      </form>
    );
  }
}

export default RemoveTargetSiteStep;
